<script setup>
import DssHeaderInbox from '@/core/components/dss-header/components/dss-header-inbox/dss-header-inbox.vue'
import DssLanguageSwitcher
  from '@/core/components/dss-header/components/dss-language-switcher/dss-language-switcher.vue'

const show = ref(false)
</script>

<template>
  <header
    id="app-header"
    class="bg-dss-surface-0 border-b border-b-dss-surface-200 h-22 pr-10 flex items-center justify-between text-dss-surface-800"
  >
    <div class="flex ml-10">
      <router-link to="/">
        <img
          class="h-7"
          src="@shared/assets/svg/logo-header.svg"
          :alt="$t('common.logo.alt')"
        >
      </router-link>
    </div>

    <div class="flex items-center gap-5">
      <IconField v-if="show">
        <InputIcon class="pi pi-search text-dss-surface-600!" />
        <InputText
          v-model="value1"
          size="small"
          :placeholder="$t('common.search')"
          class="bg-dss-surface-100! border-dss-surface-200! text-dss-surface-800! py-2.5! rounded!"
          :unstyled="false"
        />
      </IconField>

      <dss-header-inbox v-if="show" />

      <dss-language-switcher />

      <dss-header-user />
    </div>
  </header>
</template>

<style scoped>
.badge-icon span {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translate(50%, -50%);
  transform-origin: 100% 0;
  margin: 0;
}
</style>
